import { observer } from 'mobx-react-lite'
import { NotifyProsOfOpenJobDialog } from '@/features/jobs/details/components/NotifyProsOfOpenJobDialog'
import { type NotifyProsOfOpenJobDialogViewModel } from './NotifyProsOfOpenJobDialogViewModel'

export interface NotifyProsOfOpenJobDialogContainerProps {
  vm: NotifyProsOfOpenJobDialogViewModel
}

export const NotifyProsOfOpenJobDialogContainer = observer(
  function NotifyProsOfOpenJobDialogContainer({
    vm,
  }: NotifyProsOfOpenJobDialogContainerProps) {
    return (
      <NotifyProsOfOpenJobDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onNotify={vm.notifyProsOfOpenJob}
        isNotifyPending={vm.notifyProsOfOpenJob.pending}
        submitButtonTestId="notify-pros-of-open-job-button"
      />
    )
  },
)
